// ================= KOMPLETNÍ APP S EXPORTEM PDF + ROZŠÍŘENOU LEGENDOU =================
import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, Link, useNavigate, Navigate } from "react-router-dom";
import { initializeApp } from "firebase/app";
import { getFirestore, doc, setDoc, getDoc } from "firebase/firestore";
import { getAuth, signInWithEmailAndPassword, onAuthStateChanged, signOut } from "firebase/auth";

// ================= FIREBASE =================
const firebaseConfig = {
  apiKey: "AIzaSyAf759uMsQaN8pgTV8OlaeUSAQmE1HA-X4",
  authDomain: "ceskypohar-ec340.firebaseapp.com",
  projectId: "ceskypohar-ec340",
  storageBucket: "ceskypohar-ec340.firebasestorage.app",
  messagingSenderId: "520604761899",
  appId: "1:520604761899:web:c63aa672e49c3571c50f6e"
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const auth = getAuth();

// ================= BODY =================
const pointsTable = {
  1:200,2:180,3:160,4:150,5:145,6:140,7:136,8:132,9:129,10:126,
  11:124,12:122,13:120,14:118,15:116,16:115,17:114,18:113,19:112,20:111,
  21:110,22:109,23:108,24:107,25:106,26:105,27:104,28:103,29:102,30:101,
  31:100,32:99,33:98,34:97,35:96,36:95,37:94,38:93,39:92,40:91,
  41:90,42:89,43:88,44:87,45:86,46:85,47:84,48:83,49:82,50:81
};

const getPoints = (p) => {
  if (p === "DQ") return 50;
  const n = Number(p);
  return isNaN(n) ? 0 : pointsTable[n] || 0;
};

// ================= RESULTS PAGE =================
function ResultsPage({ year, category, data }) {
  const yearData = data[year] || { categories:{}, races:[] };
  const racers = yearData.categories[category] || [];
  const races = yearData.races || [];
  const colors = ["#3b82f6","#f97316"];

  const racersWithPoints = racers.map(r=>{
    const allPoints = [];
    r.results?.forEach((res,ri)=>{
      res.slaloms?.forEach((p,si)=>{
        allPoints.push({ pts: getPoints(p), ri, si });
      });
    });

    const numNotCounted = Math.round(allPoints.length * 0.1);
    const sorted = [...allPoints].sort((a,b)=>a.pts-b.pts);
    const notCountedIndices = sorted.slice(0,numNotCounted).map(x=>`${x.ri}-${x.si}`);

    const totalPoints = allPoints.reduce((sum,x)=>{
      const key = `${x.ri}-${x.si}`;
      return notCountedIndices.includes(key) ? sum : sum + x.pts;
    },0);

    return {...r, totalPoints, notCountedIndices};
  });

  const sortedRacers = [...racersWithPoints].sort((a,b)=>b.totalPoints-a.totalPoints);

  return (
    <div style={styles.page}>
      <h1 style={styles.heading}>ČESKÝ POHÁR {year} | {category}</h1>

      <div style={styles.tableWrap}>
        <table style={styles.table}>
          <thead>
            <tr>
              <th style={styles.stickyLeft}>Závodník</th>
              <th style={styles.stickyLeft2}>Body</th>
              {races.map((race,i)=>
                <th key={i} colSpan={race.slaloms?.length || 2} style={{background:colors[i%2],color:"#fff"}}>
                  {race.name}
                </th>
              )}
            </tr>
            <tr>
              <th style={styles.stickyLeft}></th>
              <th style={styles.stickyLeft2}></th>
              {races.map((race,i)=>race.slaloms?.map((s,si)=>
                <th key={`${i}-${si}`} style={{background:colors[i%2],color:"#fff"}}>{s}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {sortedRacers.map((r,i)=>(
              <tr key={i} style={i<3 ? styles.topRow : null}>
                <td style={styles.stickyLeft}>
                  <div style={styles.nameCell}>
                    <span style={{
                      ...styles.rankBadge,
                      background: i===0 ? "#facc15" : i===1 ? "#e5e7eb" : i===2 ? "#f97316" : "#e5e7eb"
                    }}>
                      {i+1}
                    </span>
                    <span style={styles.name}>{r.name}</span>
                  </div>
                </td>
                <td style={styles.stickyLeft2}>
                  <span style={styles.totalBadge}>{r.totalPoints}</span>
                </td>
                {r.results?.map((res,ri)=>res.slaloms?.map((p,si)=>{
                  const pts = getPoints(p);
                  const key = `${ri}-${si}`;
                  const isCounted = !r.notCountedIndices?.includes(key);
                  let style = styles.counted;
                  if (!isCounted) style = styles.notCounted;
                  if (pts === 0) style = styles.zero;
                  return <td key={key} style={style}>{pts}</td>;
                }))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div style={styles.legend}>
        <div style={styles.legendItem}>
          <span style={{...styles.legendDot,background:"#15803d"}}/>Započítané
        </div>
        <div style={styles.legendItem}>
          <span style={{...styles.legendDot,background:"#b91c1c"}}/>Nezapočítané
        </div>
        <div style={styles.legendItem}>
          <span style={{...styles.legendDot,background:"#999"}}/>Bez bodů
        </div>
      </div>

      {/* Nový text k systému 90 % výsledků */}
      <div style={styles.ruleBox}>
        Do celkového hodnocení Českého poháru se každému závodníkovi započítává 90% nejlepších výsledků ze všech uskutečněných slalomů.
        Např. bude dohromady možno absolvovat 16 slalomů. 90% z 16 je 14,4 po zaokrouhlení 14 slalomů.
        Absolvuje‑li závodník 16 slalomů, bude mu započteno 14 nejlepších dosažených bodových výsledků (dva nejhorší budou v tomto případě škrtnuty).
      </div>
    </div>
  );
}

// ================= NOVÝ RACES ADMIN S EDITACÍ NAZVŮ =================
function RacesAdmin({ races, yearData, updateData }) {
  const [newRaceName, setNewRaceName] = useState('');
  const [newSlalomsCount, setNewSlalomsCount] = useState(2);
  const [editingRaceIndex, setEditingRaceIndex] = useState(null);
  const [editRaceName, setEditRaceName] = useState('');
  
  const slalomNames = ['GS', 'TS', 'HS']; 

  const addRace = () => {
    if (!newRaceName.trim()) return;
    const slaloms = Array.from({length: newSlalomsCount}, (_, i) => slalomNames[i]);
    const newRaces = [...races, { name: newRaceName.trim(), slaloms }];
    const newData = { ...yearData, races: newRaces };
    updateData(newData);
    setNewRaceName('');
    setNewSlalomsCount(2);
  };

  const updateSlalomsCount = (index, count) => {
    const newRaces = [...races];
    newRaces[index].slaloms = Array.from({length: count}, (_, i) => slalomNames[i]);
    const newData = { ...yearData, races: newRaces };
    updateData(newData);
  };

  const deleteRace = (index) => {
    const newRaces = races.filter((_, i) => i !== index);
    const newData = { ...yearData, races: newRaces };
    updateData(newData);
  };

  const startEditRace = (index) => {
    setEditingRaceIndex(index);
    setEditRaceName(races[index].name);
  };

  const saveEditRace = () => {
    const newRaces = [...races];
    newRaces[editingRaceIndex].name = editRaceName.trim();
    const newData = { ...yearData, races: newRaces };
    updateData(newData);
    setEditingRaceIndex(null);
    setEditRaceName('');
  };

  return (
    <div style={styles.adminSection}>
      <h2>🏁 Závody ({races.length})</h2>
      
      {/* PŘIDÁNÍ NOVÉHO ZÁVODU */}
      <div style={styles.inputRow}>
        <input 
          value={newRaceName} 
          onChange={e => setNewRaceName(e.target.value)} 
          placeholder="Nový závod (např. Liberec)" 
          style={styles.input}
        />
        <select 
          value={newSlalomsCount} 
          onChange={e => setNewSlalomsCount(Number(e.target.value))} 
          style={{...styles.input, width: '140px'}}
        >
          <option value={1}>1 slalom (GS)</option>
          <option value={2}>2 slalomy (GS+TS)</option>
          <option value={3}>3 slalomy (GS+TS+HS)</option>
        </select>
        <button onClick={addRace} style={styles.btnPrimary}>➕ Přidat závod</button>
      </div>
      
      {/* SEZNAM ZÁVOŮ S EDITACÍ */}
      <div style={styles.racersList}>
        {races.map((race, i) => (
          <div key={i} style={styles.raceItem}>
            {editingRaceIndex === i ? (
              <>
                <input 
                  value={editRaceName} 
                  onChange={e => setEditRaceName(e.target.value)}
                  style={{...styles.input, flex: 1, marginRight: '10px'}}
                  placeholder="Nový název závodu"
                />
                <div style={{display: 'flex', gap: '10px', alignItems: 'center'}}>
                  <button onClick={saveEditRace} style={styles.btnPrimary}>✓ Uložit</button>
                  <button onClick={() => setEditingRaceIndex(null)} style={styles.btnDanger}>✗ Zrušit</button>
                </div>
              </>
            ) : (
              <>
                <div>
                  <strong>{race.name}</strong>
                  <span style={{marginLeft: '15px', color: '#64748b'}}>
                    {race.slaloms.join(', ')} ({race.slaloms.length} slalomů)
                  </span>
                </div>
                <div style={{display: 'flex', gap: '10px', alignItems: 'center'}}>
                  <button 
                    onClick={() => startEditRace(i)} 
                    style={{...styles.btnPrimary, padding: '8px 12px', fontSize: '14px'}}
                  >
                    ✏️ Upravit název
                  </button>
                  <select
                    value={race.slaloms.length}
                    onChange={(e) => updateSlalomsCount(i, Number(e.target.value))}
                    style={{width: '140px', ...styles.input}}
                  >
                    <option value={1}>1 slalom</option>
                    <option value={2}>2 slalomy</option>
                    <option value={3}>3 slalomy</option>
                  </select>
                  <button onClick={() => deleteRace(i)} style={styles.btnDanger}>🗑️</button>
                </div>
              </>
            )}
          </div>
        ))}
      </div>
      
      {races.length === 0 && (
        <div style={{textAlign: 'center', color: '#64748b', padding: '40px'}}>
          <p>Žádné závody. Přidej první závod výše! 🏁</p>
        </div>
      )}
    </div>
  );
}

// ================= RESULTS EDITOR =================
function ResultsEditor({ racers, races, yearData, updateData, selectedCategory }) {
  const [selectedRacerIndex, setSelectedRacerIndex] = useState(0);
  const racer = racers[selectedRacerIndex] || racers[0];
  
  if (!racer || races.length === 0) {
    return <div style={styles.adminSection}>Nejdřív přidej závodníky a závody</div>;
  }

  const updatePlacement = (raceIndex, slalomIndex, value) => {
    const newRacers = [...racers];
    if (!newRacers[selectedRacerIndex].results) {
      newRacers[selectedRacerIndex].results = races.map(() => ({ slaloms: [] }));
    }
    if (!newRacers[selectedRacerIndex].results[raceIndex]) {
      newRacers[selectedRacerIndex].results[raceIndex] = { slaloms: [] };
    }
    newRacers[selectedRacerIndex].results[raceIndex].slaloms[slalomIndex] = value;
    
    const newData = {
      ...yearData,
      categories: { ...yearData.categories, [selectedCategory]: newRacers }
    };
    updateData(newData);
  };

  return (
    <div style={styles.adminSection}>
      <h2>📊 Výsledky - {racer.name}</h2>
      
      <div style={{...styles.inputRow, marginBottom: '30px'}}>
        <select 
          value={selectedRacerIndex} 
          onChange={e => setSelectedRacerIndex(Number(e.target.value))}
          style={{...styles.input, minWidth: '300px'}}
        >
          {racers.map((r, i) => (
            <option key={i} value={i}>{r.name}</option>
          ))}
        </select>
        <div style={{color: '#64748b', alignSelf: 'center'}}>
          Zvol závodníka a vyplň jeho výsledky ↓
        </div>
      </div>

      <div style={styles.resultsEditorGrid}>
        {races.map((race, raceIndex) => (
          <div key={raceIndex} style={styles.raceColumnWide}>
            <div style={styles.raceHeader}>
              <strong>{race.name}</strong>
              <span style={{fontSize: '12px', color: '#64748b'}}>{race.slaloms.join(' + ')}</span>
            </div>
            {race.slaloms.map((slalomName, slalomIndex) => {
              const currentValue = racer.results?.[raceIndex]?.slaloms?.[slalomIndex] || '';
              return (
                <input
                  key={slalomIndex}
                  value={currentValue}
                  onChange={(e) => updatePlacement(raceIndex, slalomIndex, e.target.value.toUpperCase())}
                  placeholder={` ${slalomName} (1-50/DQ)`}
                  style={styles.largePlacementInput}
                  maxLength="3"
                />
              );
            })}
          </div>
        ))}
      </div>
      
      <div style={{marginTop: '20px', padding: '15px', background: '#f0fdf4', borderRadius: '8px', borderLeft: '4px solid #15803d'}}>
        💡 <strong>Tip:</strong> Piš čísla 1-50 nebo "DQ". Nejhorší 10% výsledků se automaticky nezapočítá.
      </div>
    </div>
  );
}

// ================= RACERS ADMIN =================
function RacersAdmin({ racers, selectedCategory, yearData, updateData, races }) {
  const [newRacerName, setNewRacerName] = useState('');
  const [editingIndex, setEditingIndex] = useState(null);
  const [editName, setEditName] = useState('');

  // eslint-disable-next-line no-unused-vars
const initializeResults = (racerIndex) => {
  const racer = racers[racerIndex];
  if (!racer.results || racer.results.length !== races.length) {
    const newResults = races.map(() => ({ slaloms: [] }));
    const newRacers = [...racers];
    newRacers[racerIndex] = { ...racer, results: newResults };
    const newData = { 
      ...yearData, 
      categories: { ...yearData.categories, [selectedCategory]: newRacers } 
    };
    updateData(newData);
  }
};


  const addRacer = () => {
    if (!newRacerName.trim()) return;
    const newResults = races.map(() => ({ slaloms: [] }));
    const newRacers = [...racers, { name: newRacerName.trim(), results: newResults }];
    const newData = { 
      ...yearData, 
      categories: { ...yearData.categories, [selectedCategory]: newRacers } 
    };
    updateData(newData);
    setNewRacerName('');
  };

  const deleteRacer = (index) => {
    const newRacers = racers.filter((_, i) => i !== index);
    const newData = { 
      ...yearData, 
      categories: { ...yearData.categories, [selectedCategory]: newRacers } 
    };
    updateData(newData);
  };

  const saveEdit = (index) => {
    const newRacers = [...racers];
    newRacers[index].name = editName.trim();
    const newData = { 
      ...yearData, 
      categories: { ...yearData.categories, [selectedCategory]: newRacers } 
    };
    updateData(newData);
    setEditingIndex(null);
  };

  const startEdit = (index, name) => {
    setEditingIndex(index);
    setEditName(name);
  };

  return (
    <div style={styles.adminSection}>
      <h2>🧑‍🎤 Závodníci - {selectedCategory} ({racers.length})</h2>
      
      <div style={styles.inputRow}>
        <input 
          value={newRacerName} 
          onChange={e => setNewRacerName(e.target.value)} 
          placeholder="Nový závodník (např. Petr Novák)" 
          style={styles.input}
        />
        <button onClick={addRacer} style={styles.btnPrimary}>➕ Přidat</button>
      </div>
      
      <div style={{...styles.racersList, marginBottom: '30px'}}>
        {racers.map((r, i) => (
          <div key={i} style={styles.racerItem}>
            {editingIndex === i ? (
              <>
                <input 
                  value={editName} 
                  onChange={e => setEditName(e.target.value)} 
                  style={{...styles.input, flex: 1, marginRight: '10px'}}
                />
                <div style={{display: 'flex', gap: '10px'}}>
                  <button onClick={() => saveEdit(i)} style={styles.btnPrimary}>✓ Uložit</button>
                  <button onClick={() => setEditingIndex(null)} style={styles.btnDanger}>✗ Zrušit</button>
                </div>
              </>
            ) : (
              <>
                <span style={{fontWeight: '600', fontSize: '16px'}}>{r.name}</span>
                <div style={{display: 'flex', gap: '10px'}}>
                  <button onClick={() => startEdit(i, r.name)} style={{...styles.btnPrimary, padding: '8px 12px'}}>
                    ✏️ Upravit jméno
                  </button>
                  <button onClick={() => deleteRacer(i)} style={styles.btnDanger}>🗑️</button>
                </div>
              </>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}

// ================= DATA ADMIN (EXPORT JSON + PDF) =================
function DataAdmin({ year, data, updateData }) {
  const exportData = () => {
    const json = JSON.stringify(data, null, 2);
    const blob = new Blob([json], { type: 'application/json' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `cesky-pohar-${year}.json`;
    a.click();
  };

  const openResultsPrint = () => {
    window.open('/results', '_blank');
  };

  return (
    <div style={styles.adminSection}>
      <h2>💾 Import/Export</h2>
      <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
        <button onClick={exportData} style={styles.btnPrimary}>⬇️ Export JSON</button>
        <button onClick={openResultsPrint} style={styles.btnPrimary}>🖨️ Export do PDF</button>
      </div>
      <p style={{ marginTop: '20px', color: '#64748b' }}>
        Import zatím není implementován. Pro PDF otevři výsledky a v prohlížeči použij Tisk → Uložit jako PDF.
      </p>
    </div>
  );
}

// ================= ADMIN PAGE =================
function AdminPage({ year, data, setData, categories }) {
  const [adminView, setAdminView] = useState('dashboard');
  const [selectedCategory, setSelectedCategory] = useState('PRO');
  const navigate = useNavigate();

  const yearData = data[year] || { categories: {}, races: [] };
  const racers = yearData.categories[selectedCategory] || [];
  const races = yearData.races || [];

  const updateData = async (newData) => {
    await setDoc(doc(db, "cpData", year.toString()), newData);
    setData(prev => ({ ...prev, [year]: newData }));
  };

  return (
    <div style={styles.adminPage}>
      <div style={styles.adminNavbar}>
        <button onClick={() => setAdminView('dashboard')} style={adminView === 'dashboard' ? styles.activeTab : styles.tab}>
          📊 Dashboard
        </button>
        <button onClick={() => setAdminView('racers')} style={adminView === 'racers' ? styles.activeTab : styles.tab}>
          🧑‍🎤 Závodníci
        </button>
        <button onClick={() => setAdminView('results')} style={adminView === 'results' ? styles.activeTab : styles.tab}>
          📊 Výsledky
        </button>
        <button onClick={() => setAdminView('races')} style={adminView === 'races' ? styles.activeTab : styles.tab}>
          🏁 Závody
        </button>
        <button onClick={() => setAdminView('data')} style={adminView === 'data' ? styles.activeTab : styles.tab}>
          💾 Data
        </button>
        <button onClick={() => navigate('/results')} style={styles.logoutBtn}>← Výsledky</button>
      </div>

      {adminView === 'dashboard' && (
        <div style={styles.adminSection}>
          <h2>📈 Dashboard {year}</h2>
          <div style={styles.statsGrid}>
            <div style={styles.statCard}>
              <h3>{racers.length}</h3>
              <p>{selectedCategory}</p>
            </div>
            <div style={styles.statCard}>
              <h3>{races.length}</h3>
              <p>Závodů</p>
            </div>
          </div>
          <select value={selectedCategory} onChange={e => setSelectedCategory(e.target.value)} style={styles.select}>
            {categories.map(c => <option key={c}>{c}</option>)}
          </select>
        </div>
      )}

      {adminView === 'racers' && (
        <RacersAdmin racers={racers} selectedCategory={selectedCategory} yearData={yearData} updateData={updateData} races={races} />
      )}

      {adminView === 'results' && racers.length > 0 && races.length > 0 && (
        <ResultsEditor racers={racers} races={races} yearData={yearData} updateData={updateData} selectedCategory={selectedCategory} />
      )}

      {adminView === 'races' && (
        <RacesAdmin races={races} yearData={yearData} updateData={updateData} />
      )}

      {adminView === 'data' && (
        <DataAdmin year={year} data={yearData} updateData={updateData} />
      )}
    </div>
  );
}

// ================= LOGIN PAGE =================
function LoginPage({ setIsAdmin }) {
  const [email,setEmail] = useState("");
  const [password,setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const login = async () => {
    if (!email || !password) {
      setError("Zadej email a heslo");
      return;
    }
    
    setLoading(true);
    setError("");
    
    try {
      console.log("🔐 Přihlašuji:", email);
      await signInWithEmailAndPassword(auth, email, password);
      console.log("✅ PŘIHLÁŠENÍ OK!");
      setIsAdmin(true);
      navigate("/admin");
    } catch (err) {
      console.error("❌ LOGIN CHYBA:", err.code, err.message);
      const errorMsg = err.code === 'auth/wrong-password' ? 'Špatné heslo' : 
                      err.code === 'auth/user-not-found' ? 'Účet neexistuje v projektu' : 
                      'Chyba přihlášení';
      setError(errorMsg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.page}>
      <h2 style={styles.heading}>🔐 Admin Přihlášení</h2>
      <div style={{maxWidth: '350px', margin: '0 auto', display: 'flex', flexDirection: 'column', gap: '15px'}}>
        <input 
          value={email} 
          onChange={e=>setEmail(e.target.value)} 
          placeholder="admin@example.com" 
          style={{...styles.input, padding: '12px'}}
        />
        <input 
          value={password} 
          onChange={e=>setPassword(e.target.value)} 
          type="password" 
          placeholder="Heslo" 
          style={{...styles.input, padding: '12px'}}
        />
        {error && <div style={{color: '#dc2626', padding: '10px', background: '#fee2e2', borderRadius: '6px'}}>{error}</div>}
        <button 
          onClick={login} 
          disabled={loading}
          style={{...styles.btnPrimary, opacity: loading ? 0.7 : 1, padding: '12px'}}
        >
          {loading ? "⏳ Přihlašuji..." : "🚀 Přihlásit"}
        </button>
        <div style={{fontSize: '12px', color: '#64748b'}}>
          Otevři Console (F12) pro debug informace
        </div>
      </div>
    </div>
  );
}

// ================= APP =================
function App() {
  const categories = ["PRO","AM","MASTERS","WOMEN","WOMEN MASTERS","JUNIORS","TEENS","KIDS"];
  const currentYear = new Date().getFullYear();
  const years = Array.from({length:currentYear-2017},(_,i)=>2018+i).reverse();

  const [year,setYear] = useState(currentYear);
  const [category,setCategory] = useState(categories[0]);
  const [data,setData] = useState({});
  const [isAdmin,setIsAdmin] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, user => {
      setIsAdmin(!!user);
      setLoading(false);
    });
    return unsubscribe;
  }, []);

  useEffect(() => {
    const fetch = async () => {
      try {
        const snap = await getDoc(doc(db, "cpData", year.toString()));
        if (snap.exists()) {
          setData(prev => ({ ...prev, [year]: snap.data() }));
        }
      } catch (err) {
        console.error("Načítání dat selhalo:", err);
      }
    };
    fetch();
  }, [year]);

  if (loading) {
    return <div style={styles.page}>Načítám...</div>;
  }

  return (
    <Router>
      {/* NAVBAR S LOGINEM DOPRAVA */}
      <div style={styles.navbar}>
        <div style={styles.leftNav}>
          <Link to="/results" style={styles.link}>🏁 Výsledky</Link>
        </div>
        
        <div style={styles.centerNav}>
          <select value={category} onChange={e=>setCategory(e.target.value)} style={styles.select}>
            {categories.map(c=><option key={c}>{c}</option>)}
          </select>
          <select value={year} onChange={e=>setYear(Number(e.target.value))} style={styles.select}>
            {years.map(y=><option key={y}>{y}</option>)}
          </select>
        </div>
        
        {/* LOGIN/LOGOUT DOPRAVA NAHORE */}
        <div style={styles.rightNav}>
          {isAdmin ? (
            <>
              <Link to="/admin" style={styles.link}>⚙️ Admin</Link>
              <button 
                onClick={async () => {
                  await signOut(auth);
                  setIsAdmin(false);
                }} 
                style={styles.logoutButton}
              >
                🚪 Odhlásit
              </button>
            </>
          ) : (
            <Link to="/login" style={styles.loginButton}>🔐 Login</Link>
          )}
        </div>
      </div>

      <Routes>
        <Route path="/results" element={<ResultsPage year={year} category={category} data={data} />} />
        <Route path="/login" element={<LoginPage setIsAdmin={setIsAdmin} />} />
        <Route 
          path="/admin" 
          element={
            isAdmin ? (
              <AdminPage year={year} data={data} setData={setData} categories={categories} />
            ) : (
              <Navigate to="/login" />
            )
          } 
        />
        <Route path="*" element={<ResultsPage year={year} category={category} data={data} />} />
      </Routes>
    </Router>
  );
}

// ================= FINAL STYLY =================
const styles = {
  page:{ padding:"20px", background:"#f5f6fa", minHeight:"100vh" },
  heading:{ color:"#0f172a", marginBottom:"20px", fontSize: "28px" },
  
  navbar: {
    background: "#0f172a", 
    padding: "12px 20px", 
    display: "flex", 
    justifyContent: "space-between",
    alignItems: "center",
    flexWrap: "wrap",
    gap: "15px",
    boxShadow: "0 4px 12px rgba(0,0,0,0.1)"
  },
  leftNav: { display: "flex", gap: "15px" },
  centerNav: { display: "flex", gap: "10px", alignItems: "center" },
  rightNav: { 
    display: "flex", 
    gap: "10px", 
    alignItems: "center",
    marginLeft: "auto"
  },
  loginButton: {
    color: "#fff", 
    textDecoration: "none", 
    fontWeight: "600",
    padding: "10px 20px",
    background: "#3b82f6",
    borderRadius: "8px",
    fontSize: "14px"
  },
  logoutButton: {
    background: "#dc2626", 
    color: "white", 
    padding: "10px 20px", 
    borderRadius: "8px",
    border: "none",
    fontWeight: "600",
    cursor: "pointer",
    fontSize: "14px",
    textDecoration: "none"
  },
  
  link:{ 
    color:"#fff", 
    textDecoration:"none", 
    fontWeight:"600",
    padding: "10px 16px",
    borderRadius: "6px"
  },
  select:{ 
    padding:"8px 12px", 
    borderRadius:"6px", 
    border: "1px solid #475569",
    background: "white",
    fontSize: "14px"
  },
  
  tableWrap:{
    overflowX:"auto",
    background:"white",
    borderRadius:"16px",
    boxShadow:"0 10px 30px rgba(0,0,0,0.08)",
    marginBottom: "20px"
  },
  table:{ width:"100%", borderCollapse:"collapse", fontSize:"13px" },

  stickyLeft: {
    position: "sticky",
    left: 0,
    background: "white",
    zIndex: 4,
    borderRight: "2px solid #f1f5f9",
    minWidth: "180px"   // šířka sloupce se jménem
  },
  stickyLeft2: {
    position: "sticky",
    left: 180,           // stejná hodnota jako minWidth výše
    background: "white",
    zIndex: 4,
    textAlign: "center",
    borderRight: "2px solid #f1f5f9",
    minWidth: "80px"     // šířka sloupce s body
  },
  nameCell: {
    display: "flex",
    alignItems: "center",
    gap: "6px",
    fontWeight: "600",
    padding: "8px"
  },
  rankBadge:{ 
    minWidth:"26px", height:"26px", borderRadius:"50%", 
    display:"flex", alignItems:"center", justifyContent:"center", 
    fontSize:"13px", fontWeight:"700" 
  },
  name:{ whiteSpace:"nowrap", fontSize: "12px" },
  counted:{ color:"#15803d", fontWeight:"600", textAlign:"center", padding: "12px 8px" },
  notCounted:{ color:"#b91c1c", textDecoration:"line-through", textAlign:"center", opacity:0.6, padding: "12px 8px" },
  zero:{ color:"#999", textAlign:"center", padding: "12px 8px" },
  topRow:{ background:"linear-gradient(90deg,#fff8e1,#ffffff)" },
  totalBadge:{ 
    background:"#0f172a", color:"white", padding:"6px 10px", 
    borderRadius:"999px", fontWeight:"700", fontSize:"12px" 
  },

  legend:{ display:"flex", gap:"20px", marginTop:"15px", padding: "15px", background: "white", borderRadius: "12px" },
  legendItem:{ display:"flex", alignItems:"center", gap:"6px", fontSize: "14px" },
  legendDot:{ width:"12px", height:"12px", borderRadius:"50%" },

  ruleBox: {
    marginTop: "15px",
    padding: "16px 18px",
    background: "#eef2ff",
    borderRadius: "12px",
    borderLeft: "4px solid #4f46e5",
    fontSize: "13px",
    lineHeight: 1.5,
    maxWidth: "900px"
  },
  
  adminPage: { padding: '20px', background: '#f8fafc', minHeight: '100vh' },
  adminNavbar: { 
    display: 'flex', gap: '10px', background: '#1e293b', 
    padding: '15px', borderRadius: '12px', marginBottom: '20px',
    flexWrap: 'wrap'
  },
  tab: { 
    padding: '12px 24px', background: 'transparent', color: '#94a3b8', 
    border: 'none', borderRadius: '8px', cursor: 'pointer',
    fontWeight: '500', fontSize: '14px'
  },
  activeTab: { 
    background: '#0f172a', color: 'white' 
  },
  logoutBtn: { 
    marginLeft: 'auto', background: '#f97316', color: 'white', 
    padding: '12px 24px', borderRadius: '8px', border: 'none',
    fontWeight: '600'
  },
  adminSection: { 
    background: 'white', padding: '30px', borderRadius: '12px', 
    boxShadow: '0 4px 20px rgba(0,0,0,0.08)'
  },
  statsGrid: { 
    display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))', 
    gap: '20px', marginBottom: '20px' 
  },
  statCard: { 
    textAlign: 'center', padding: '30px 20px', 
    background: '#f1f5f9', borderRadius: '12px',
    boxShadow: '0 2px 10px rgba(0,0,0,0.05)'
  },
  
  inputRow: { display: 'flex', gap: '15px', marginBottom: '25px', flexWrap: 'wrap', alignItems: 'center' },
  racersList: { display: 'flex', flexDirection: 'column', gap: '12px' },
  racerItem: { 
    display: 'flex', justifyContent: 'space-between', alignItems: 'center', 
    padding: '20px', background: '#f8fafc', borderRadius: '10px',
    border: '1px solid #e2e8f0'
  },
  raceItem: { 
    display: 'flex', justifyContent: 'space-between', alignItems: 'center', 
    padding: '16px 20px', background: '#f8fafc', borderRadius: '10px',
    border: '1px solid #e2e8f0'
  },
  input: {
    padding: '12px 16px',
    border: '2px solid #e2e8f0',
    borderRadius: '8px',
    fontSize: '16px',
    minWidth: '250px',
    flex: 1
  },
  
  resultsEditorGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))',
    gap: '25px',
    marginTop: '20px'
  },
  raceColumnWide: {
    background: '#f8fafc',
    border: '1px solid #e2e8f0',
    borderRadius: '12px',
    padding: '20px',
    display: 'flex',
    flexDirection: 'column',
    gap: '12px'
  },
  raceHeader: {
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
    paddingBottom: '12px',
    borderBottom: '2px solid #e2e8f0',
    fontSize: '16px'
  },
  largePlacementInput: {
    padding: '14px',
    border: '2px solid #e2e8f0',
    borderRadius: '8px',
    fontSize: '18px',
    fontWeight: '700',
    textAlign: 'center',
    width: '100%',
    height: '55px',
    textTransform: 'uppercase'
  },
  
  btnPrimary: { 
    background: '#15803d', color: 'white', padding: '12px 24px', 
    borderRadius: '8px', border: 'none', fontWeight: '600',
    cursor: 'pointer', fontSize: '14px'
  },
  btnDanger: { 
    background: '#dc2626', color: 'white', padding: '10px 16px', 
    borderRadius: '6px', border: 'none', fontWeight: '500',
    cursor: 'pointer', fontSize: '14px'
  }
};

export default App;
